import { datadogRum } from '@datadog/browser-rum';
import { GatsbyBrowser } from 'gatsby';
import { createElement } from 'react';
import DD_OPTIONS from '@ecs/tng-common/src/scripts/data-dog-options';
import { FeatureFlagRoot } from '@ecs/tng-common/src/scripts/feature-flags';
import { setWindowElements } from '@ecs/tng-common/src/scripts/helpers';
import { scheduleGatsbyHydrationCompleteFallback } from '@ecs/tng-common/src/scripts/return-user';
import { scrollToHashWhenStable } from './src/scripts/stable-hash-scroll';

// Mount the feature-flag provider around the whole app on the client. Paired
// with the identical wrapRootElement in gatsby-ssr so the provider exists during
// SSR and hydration alike (see FeatureFlagRoot for the no-blank-HTML strategy).
export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) =>
  createElement(FeatureFlagRoot, null, element);

let cancelPendingHashScroll: (() => void) | undefined;

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({ location, prevLocation }) => {
  cancelPendingHashScroll?.();
  cancelPendingHashScroll = undefined;

  if (location.hash) {
    cancelPendingHashScroll = scrollToHashWhenStable(location.hash);
  }

  setTimeout(() => {
    if (prevLocation && location !== prevLocation) {
      setWindowElements();

      if (window.instantiatePage) {
        window.instantiatePage();
      }
    }
  }, 20);
};

export const shouldUpdateScroll: GatsbyBrowser['shouldUpdateScroll'] = ({
  routerProps: { location }
}) => {
  if (location.hash) {
    // The generic stable-hash handler owns fragment scrolling.
    return false;
  }

  // Or return true if Gatsby should restore its normal saved position.
  return [0, 0] as [number, number];
};

export const onInitialClientRender = () => {
  // Fallback only. Pages with useReturnUser/useAlerts dispatch from return-user.ts
  // after repo-side return-user/alerts assessment and loading=false.
  scheduleGatsbyHydrationCompleteFallback();
  // run dataDog script
  if (process.env.GATSBY_ENV !== 'development' && datadogRum) {
    datadogRum.init(DD_OPTIONS);
    datadogRum.startSessionReplayRecording();
  }
};
